import { render, staticRenderFns } from "./ClientsImport.vue?vue&type=template&id=30a5cf46&scoped=true&"
import script from "./ClientsImport.vue?vue&type=script&lang=js&"
export * from "./ClientsImport.vue?vue&type=script&lang=js&"
import style0 from "./ClientsImport.vue?vue&type=style&index=0&id=30a5cf46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a5cf46",
  null
  
)

export default component.exports